import React, { useEffect } from 'react';
import { useAuth } from 'context/authContext';
import { useNavigate } from 'react-router-dom';
import { ClientLoginForm } from 'components';
import CUP from 'assets/images/cup.png';

export const ClientLoginPage = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth) {
      return navigate('/');
    }
  }, [auth, navigate]);

  return (
    !auth && (
      <div className="flex relative justify-end h-full overflow-y-auto overflow-x-hidden bg-green-gradient min-h-screen">
        <div className="absolute z-10 top-0 bottom-0 left-[31%] -translate-x-1/2">
          <ClientLoginForm />
        </div>
        <div className="fixed overflow-hidden w-full h-full pointer-events-none">
          <p className="text-[40px] text-green italic uppercase text-center font-bold absolute top-1/4 right-[13%] -translate-y-1/2">
            Keep going.
            <br /> You&apos;ve got this.
          </p>
          <img
            className="absolute w-[511px] right-[7%] top-2/3 -translate-y-1/2 z-10"
            src={CUP}
            alt="cup"
          />
          <span className="[clip-path:ellipse(50vw_20vw)] w-[90vw] h-[45vw] bg-orange-gradient rotate-[-215deg] absolute -bottom-[43%] right-[-16%]" />
        </div>
      </div>
    )
  );
};
